import { initAxios } from '../../../utils/axiosHelper';
import { parseErrorMsg } from '../../../utils/errorHelper';

export interface EntityRiskRunResponse {
  success: boolean;
  result: any;
  reportFiled: boolean;
}

export const runEntityRiskEvaluation = async (
  databaseId: string,
  databaseEntityId: string,
  payload: {
    entityName: string;
    country?: string;
    address?: string;
    statedBusiness?: string;
    aliases?: string[];
    entityId?: string;
  },
): Promise<EntityRiskRunResponse> =>
  initAxios()
    .post(
      `/bite-db/database/${encodeURIComponent(
        databaseId,
      )}/entity/${encodeURIComponent(databaseEntityId)}/risk-evaluation`,
      payload,
      { timeout: 330000 },
    )
    .then((resp) => ({
      success: resp.status === 200 && Boolean(resp.data?.success),
      result: resp.data?.data?.evaluation,
      reportFiled: Boolean(resp.data?.data?.reportFiled),
    }))
    .catch((err) => {
      console.error('runEntityRiskEvaluation failed', err);
      return { success: false, result: parseErrorMsg(err), reportFiled: false };
    });
